export default "__VITE_ASSET__tBE2O8J6__"